import fetch from '../utils/fetch'
export function updateCategory(itemId, query) {
  return fetch({
    url: '/jianguan/healthyCategory/updateCategory/' + itemId,
    method: 'put',
    data: query,
    refreshToken: true
  })
}
export function createCategory(query) {
  return fetch({
    url: '/jianguan/healthyCategory/save',
    method: 'post',
    data: query,
    refreshToken: true
  })
}

export function getCategoryList(query) {
  return fetch({
    url: '/jianguan/healthyCategory/getList',
    method: 'get',
    params: query
  })
}

export function getGoodList(query) {
  return fetch({
    url: '/jianguan/healthyGoods/getGoodslist',
    method: 'get',
    params: query
  })
}

export function updateItems(itemId, query) {
  return fetch({
    url: '/jianguan/healthyGoods/updateItems/' + itemId,
    method: 'put',
    data: query,
    refreshToken: true
  })
}
export function createItems(query) {
  return fetch({
    url: '/jianguan/healthyGoods/save',
    method: 'post',
    data: query,
    refreshToken: true
  })
}
export function delItems(id) {
  return fetch({
    url: '/jianguan/healthyGoods/delItems/' + id,
    method: 'delete'
  })
}

export function updateStock(itemId, query) {
  return fetch({
    url: '/jianguan/healthyStock/updateStock/' + itemId,
    method: 'put',
    data: query,
    refreshToken: true
  })
}
export function createStock(query) {
  return fetch({
    url: '/jianguan/healthyStock/saveStock',
    method: 'post',
    data: query,
    refreshToken: true
  })
}
export function delStock(id) {
  return fetch({
    url: '/jianguan/healthyStock/delStock/' + id,
    method: 'delete'
  })
}
export function getStockList(query) {
  return fetch({
    url: '/jianguan/healthyStock/getStockList',
    method: 'get',
    params: query
  })
}
export function saveStocks (query) {
  return fetch({
    url: '/jianguan/healthyStock/saveStocks',
    method: 'post',
    data: query,
    refreshToken: true
  })
}

export function delGoods (query) {
  return fetch({
    url: '/jianguan/healthyStock/delGoods',
    method: 'post',
    data: query,
    refreshToken: true
  })
}



// WEBPACK FOOTER //
// ./src/api/jianguan.js